<template>
    <div  class="data-table">
        <div class="title" style="margin-bottom:20px" v-if="routeName=='Inverter'">发电量时段报表</div>
        <div class="title" style="margin-bottom:20px" v-else>储能电池充放电量时段报表</div>
		<div class="menu row-center" style="justify-content:space-between" >
			<div class="row-center">
				<span style="font-size:18rem">选择日期：</span>
				<el-date-picker :editable="false" :picker-options="pickerOptions" style="height: 40px !important"
								:clearable="false" class="dateSelect" v-model="date"
								:type="radio === 'day' ? 'date' : radio"
								:placeholder="new Date().toLocaleDateString().replace(/\//g, '-')">
				</el-date-picker>

				<div class="radio">
					<el-radio v-model="radio" label="year">
						年
					</el-radio>
					<el-radio v-model="radio" label="month">月</el-radio>
					<el-radio v-model="radio" label="day" >日</el-radio>
				</div>
				<div class="btn per" @click="perD" v-if="radio === 'day'">上一日</div>
				<div class="btn per" @click="perM" v-if="radio === 'month'">上一月</div>
				<div class="btn per" @click="perY" v-if="radio === 'year'">上一年</div>
				<el-button class="btn next" plain @click="nextD" v-if="radio === 'day'" :disabled="nextDayDisabled">
					下一日
				</el-button>
				<el-button class="btn next" plain @click="nextM" v-if="radio === 'month'"
						:disabled="nextDayDisabled">
					下一月
				</el-button>
				<el-button class="btn next" plain @click="nextY" v-if="radio === 'year'"
						:disabled="nextDayDisabled">下一年
				</el-button>
			</div>
			<div class="export row-center">
				<img
				style="width: 14px; height: 14px"
				src="../../../assets/img/export.png"
				alt=""
				/>
				<span
				style="font-size: 14px; cursor: pointer"
				@click="
					$store.commit('exportDiagram', {
					type: 'excel',
					version: Math.random(),
					})
				"
				>导出报表</span
				>
			</div>

		</div>
		<div class="report">
			<energyTable :radio="radio"  :pinnacleInfo="pinnacleInfo" :routeName="routeName"></energyTable>
		</div>
	</div>
</template>


<script>
	import charts from "../../../components/Energy/charts";
	import {
		POWER_ANALYSIS_BY_LOOP,InverterLoop
	} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import energyTable from "../sheet/energyTable.vue";
	import {
		perDay,
		perMonth, 
		perYear,
		nextDay,
		nextMonth,
		nextYear,
		dateFormat,
		dayStart,
		dayEnd,
		monthStart,
		monthEnd,
		yearStart,
		yearEnd,
	} from "../../../util/DateUtil";
	export default {
		name: "PowerDataBase",
		props: {
			realData: Array,
			options: Array,
			currentLoop: Object, 
			selectedLoops: Array,
		},
		components: {
			
			charts,
			energyTable
		},
		data() {
			let that = this
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				radio: "day",
				date: new Date(),
				pinnacleInfo:[],
				titles:[],  //表格头部
			};
		},
		computed: {
			
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			routeNameAndTag() {
				return [this.routeName, this.tag];
			},
			//路由名称
			routeName() {
				return this.$route.params.name;
			},
			//路由tag
			tag() {
				return this.$route.params.tag;
			},
			uid(){
				return this.$store.state.homeitem.uid
			},
			nextDayDisabled() {
				let timestamp = dateFormat("YY-mm-dd", new Date());
				let endtime = dateFormat("YY-mm-dd", this.date);
				if (this.radio === "year") {
					timestamp = dateFormat("YY", new Date());
					endtime = dateFormat("YY", this.date);
				} else if (this.radio === "month") {
					timestamp = dateFormat("YY-mm", new Date());
					endtime = dateFormat("YY-mm", this.date);
				}
				// console.log(endtime,timestamp)
				if (endtime >= timestamp) {
					return true;
				} else {
					return false;
				}
			},
			
			propsData() {
				return [
					this.radio,
					this.date,
					this.selectedLoops
				]
			}
		},
		created() {
			// this.$store.commit("uiditem","none")
			// this.requestData()
		},
		async mounted() {
			let _this = this
			_this.nextDayDisabled;
			_this.initPowerTimeData();
		},
		watch: {
			diagramStatus(n){
				if(this.$route.params.name === 'Inverter' && this.$route.params.tag === 'energy' ){
					if(n.type === 'excel' && this.pinnacleInfo.length > 0){

						let data = [
							['名称', '总发电量']
						]

						this.titles.forEach(t => {
							data[0].push(t)
						})

						this.pinnacleInfo.forEach(d => {
							data.push([d.name, d.total, ...this.titles.map(t => d[t])])
						})
						exportExcel(data, '发电量时段报表', [])

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			radio(n) {
				this.date = new Date();
				
			},
			//路由名称
			routeName() {
				return this.$route.params.name;
			},
			//路由tag
			tag() {
				return this.$route.params.tag;
			},
			propsData(n) {
				this.initPowerTimeData()
			}
		},
		methods: {
			initPowerTimeData() {
				let data = []
				if(this.routeName=="Inverter"){
					let promises = [];
					this.selectedLoops.forEach((item,index)=>{
						let start = dayStart(new Date(this.date))
						let end = dayEnd(new Date(this.date))
						if(this.radio=='month'){
							start = monthStart(new Date(this.date))
							end = monthEnd(new Date(this.date))
						}else if(this.radio=='year'){
							start = yearStart(new Date(this.date))
							end = yearEnd(new Date(this.date))
						}
						let obj = {
							start: start,
							end: end,
							loopId:item.loopId,
							range:this.radio.toUpperCase()
						}
						promises.push(
							InverterLoop(obj)
						);
					})
					Promise.all(promises).then((res) => {
						 let pointsArray = res.map((r) => (r.data ? r.data.data.points : []));
						 let xdata = []
						for(let i = 0; i < 24; i++){
							xdata.push((i<10?'0'+i:i)+':00')
						}
						if(this.radio=='month'){
							xdata = []
							for (let i = 0; i < 31; i++) {
								xdata.push(i+1+'日')
							}
						}else if(this.radio=='year'){
							xdata = []
							for (let i = 0; i < 12; i++) {
								xdata.push(i+1+'月')
							}
						}
						this.titles = xdata
						pointsArray.forEach((arr,i) => {
							if(arr.length>0){
								let newArry = {};
								let total = 0;
								for(let item in arr){
									total+=Number(arr[item].toFixed(2))
									newArry[xdata[item]] = arr[item].toFixed(2);
								}
								newArry["total"] = total.toFixed(2)
								newArry["name"] = this.selectedLoops[i].loopName
								data.push(newArry)
							}
						});
					})
					console.log(data)
				}else{
					this.selectedLoops.forEach(item=>{
						let day_rush = 0
						let day_put = 0
						let info = {}
						if(item.label=="电池堆"){
							info ={
								name:item.label,
								day_rush:day_rush,
								day_put:day_put,
								"0_rush":38,
								"0_put":0,
								"1_rush":24,
								"1_put":0,
								"2_rush":36,
								"2_put":0,
								"3_rush":38,
								"3_put":0,
								"4_rush":24,
								"4_put":0,
								"5_rush":0,
								"5_put":0,
								"6_rush":0,
								"6_put":0,
								"7_rush":0,
								"7_put":0,
								"8_rush":0,
								"8_put":0,
								"9_rush":0,
								"9_put":0,
								"10_rush":0,
								"10_put":0,
								"11_rush":0,
								"11_put":0,
								"12_rush":0,
								"12_put":0,
								"13_rush":0,
								"13_put":0,
								"14_rush":0,
								"14_put":0,
								"15_rush":0,
								"15_put":0,
								"16_rush":0,
								"16_put":0,
								"17_rush":0,
								"17_put":0,
								"18_rush":0,
								"18_put":0,
								"19_rush":0,
								"19_put":0,
								"20_rush":0,
								"20_put":35,
								"21_rush":0,
								"21_put":61,
								"22_rush":0,
								"22_put":38,
								"23_rush":0,
								"23_put":26
							}
						}else{
							info ={
								name:item.label,
								day_rush:day_rush,
								day_put:day_put,
								"0_rush":7,
								"0_put":0,
								"1_rush":11,
								"1_put":0,
								"2_rush":5,
								"2_put":0,
								"3_rush":14,
								"3_put":0,
								"4_rush":9,
								"4_put":0,
								"5_rush":0,
								"5_put":0,
								"6_rush":0,
								"6_put":0,
								"7_rush":0,
								"7_put":0,
								"8_rush":0,
								"8_put":0,
								"9_rush":0,
								"9_put":0,
								"10_rush":0,
								"10_put":0,
								"11_rush":0,
								"11_put":0,
								"12_rush":0,
								"12_put":0,
								"13_rush":0,
								"13_put":0,
								"14_rush":0,
								"14_put":0,
								"15_rush":0,
								"15_put":0,
								"16_rush":0,
								"16_put":0,
								"17_rush":0,
								"17_put":0,
								"18_rush":0,
								"18_put":0,
								"19_rush":0,
								"19_put":0,
								"20_rush":0,
								"20_put":6,
								"21_rush":0,
								"21_put":7,
								"22_rush":0,
								"22_put":4,
								"23_rush":0,
								"23_put":9
							}
						}
						for (i in info) {
							let hour = new Date().getHours()
							if(i.split('_')[0]>hour){
								info[i] = ""
							}
							if(i.indexOf("rush")>-1){
								day_rush+=info[i]
							}
							if(i.indexOf("put")>-1){
								day_put+=info[i]
							}
						}
						info.day_rush = day_rush
						info.day_put = day_put
						data.push(info)
					})
				}
				this.pinnacleInfo = data
			},
			perD() {
				this.date = perDay(this.date);
			},
			nextD() {
				this.date = nextDay(this.date);
			},
			perM() {
				this.date = perMonth(this.date);
			},
			nextM() {
				this.date = nextMonth(this.date);
			},
			perY() {
				this.date = perYear(this.date);
			},
			nextY() {
				this.date = nextYear(this.date);
			},

		},
	};
</script>

<style scoped lang="less">
	
	.footer {
		.info {
            padding: 39px 24px;
            align-items: flex-start;
			.item {
				width: 20%;

                .row {
                    margin-bottom: 22px;
                }

				.k {
					margin-right: 9px;
				}

				.v {
					color: rgba(13, 148, 255, 1) !important;
				}

				.txt {
					font-size: 18px;
					font-weight: 400;
					color: #333333;
				}

				.title {
					margin-bottom: 23px;

				}
			}
		}

		.tit {
			height: 57px;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #333333;
			line-height: 57px;
			border-bottom: 1px solid rgba(0, 0, 0, .15);
			padding: 0 25px;
		}
	}

	.tit-com {
		font-size: 18rem;
		font-weight: 400;
		color: #333333;
		border-left: 4px solid rgba(13, 148, 255, 1);
		height: 18px;
		line-height: 18px;
		padding-left: 17px;
	}

	.radio-3 {
		span {
			font-size: 18px;
			font-weight: 400;
			color: #333333;
		}

		div {
			width: 33.33%;
			height: 33px;
			line-height: 33px;
			text-align: center;
			font-size: 18px;
			font-weight: 400;
			color: #333333;
			border: 1px solid rgba(51, 51, 51, .15);
			cursor: pointer;

			&:hover, &.active {
				color: rgba(13, 148, 255, 1);
				border: 1px solid rgba(13, 148, 255, 1);
			}
		}
	}

	.loadfactor {
		width: 120rem;
		text-align: center;
	}

	.el-dropdown-menu__item.active {
		color: #0d94ff;
	}

	.alarming {
		// color: #fd4238 !important;
	}

	.breaker-data-1 {
		.h(968) !important;
	}

	.tab-breaker {
		> div {
			font-size: 18rem;
			font-weight: 400;
			color: #999999;
			border-top: 2px solid #ffffff;
			padding-top: 23rem;
			margin-right: 25rem;

			&.active {
				font-weight: bold;
				color: #0d94ff;
				border-top: 2px solid rgba(13, 148, 255, 1);
			}
		}
	}

	.transformerClass {
		.h(570) !important;

		.echarts {
			.left {
				.h(400) !important;
			}
		}

		.max-right {
			.h(400) !important;
		}
	}

	.transformer-data {
		padding: 0 24rem;
		background-color: #fff;
		.h(389);

		.card-list {
			.card-item {
				.w(298);
				.h(254);
				padding: 0rem 24rem;
				border-radius: 4px;
				background-color: rgba(0, 43, 102, 0.04);
				position: relative;

				h5 {
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}

				span {
					font-size: 24rem;
					font-weight: bold;
					color: #0d94ff;
					// margin-top: 8rem;
				}

				.val-details {
					width: 100%;
					justify-content: space-between;
					// margin-top: 20rem;

					span {
						font-size: 16rem;
						font-weight: 400;
						color: #999999 !important;
					}
				}
			}

			.type-2 {

				// padding-top: 70rem;
				span {
					margin-top: 25rem;
				}
			}

			.type-3 {
				align-items: flex-start;
				padding: 0 20rem;

				h4 {
					font-size: 24px;
					font-weight: bold;
					color: #f5aa00;
				}

				h5.sub-title {
					font-size: 17rem;
					color: rgba(51, 51, 51, 1);
					font-weight: bold;
				}

				p {
					font-size: 14rem;
					color: rgba(153, 153, 153, 1);
				}

				h5,
				p {
					line-height: 32rem;
				}
			}

			.type-4 {
				// padding-bottom: 12px;

				.other {
					span {
						font-size: 16rem;
						font-weight: 400;
						color: #999999;
					}
				}
			}

			.type-1 .column-center,
			.type-4 .column-center {
				height: 90rem;
				// width: 100%;
			}

			.type-1 .column-center:first-child,
			.type-4 .column-center:first-child {
				// height: 135rem;
				// padding-top: 20rem;
				// justify-content: initial;
				// width: 100%;
			}

			.other {
				position: absolute;
				bottom: 12rem;
			}
		}

		.tab {
			span {
				display: inline-block;

				min-width: 88rem;
				line-height: 64rem;
				border-top: 2px solid #ffffff;
				font-size: 18rem;
				text-align: center;
				margin-right: 29rem;
				transition: all 0.3s;
				font-weight: 400;
				color: #999999;

				&.active {
					border-top: 2px solid rgba(13, 148, 255, 1);
					color: #0d94ff;
					font-weight: bold;
				}
			}
		}
	}

	.tree {
		width: 100%;
		background-color: #fff;
		transition: all 0.5s;
		overflow: hidden;
		box-shadow: 0 0 2px 0 #8c939d;

		.data {
			width: 100%;
			margin-top: 8rem;
			height: 100%;
		}

		.option {
			width: 100%;
			.h(40);
			border-bottom: 1px solid rgba(0, 0, 0, 0.06);
			padding: 0 16rem;
			font-size: 14rem;
			font-weight: 300;
			color: #333333;
			line-height: 36rem;

			.all {
				cursor: pointer;

				img {
					// width: 16rem;
					// height: 16rem;
					margin-right: 8rem;
				}

				span {
					&:hover {
						color: rgba(13, 148, 255, 1);
					}
				}
			}

			> span {
				cursor: pointer;
				color: rgba(13, 148, 255, 1);
			}
		}
	}

	.nodes-tree {
		.w(260);
		height: 40px;
		margin-right: 8rem;
		background-color: #ffffff;
	}

	.report {
		margin-top: 24rem;
		.h(815);
	}

	.export {
		margin-left: 23rem;

		img {
			margin-right: 7rem;
		}

		span {
			font-size: 18rem;
			font-weight: 500;
			color: #333333;
		}
	}

	.btn {
		.w(96);
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 18px;
		font-weight: 400;
		color: #ffffff;
		background-color: #0d94ff;
		cursor: pointer;
		border-radius: 4rem;
		overflow: hidden;
		padding: 0px;
	}

	.per,
	.next {
		background-color: #fff;
		font-size: 18rem;
		color: #666666;
		font-weight: 400;
		border: 1px solid rgba(0, 0, 0, 0.15);

		&:hover {
			background-color: #0d94ff;
			color: #ffffff;
		}
	}

	.el-button.is-plain:hover {
		background-color: #0d94ff !important;
		color: #ffffff !important;
		transition: 0s;
	}

	.el-button.is-active,
	.el-button.is-plain:active,
	.el-button.is-plain:focus {
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, 0.15);
		color: #666666;
	}

	.el-button.is-disabled:hover {
		background-color: #ffffff !important;
		color: #c0c4cc !important;
		transition: 0s;
	}

	.per {
		// margin-left: 24rem;
	}

	.next {
		margin-left: 8rem;
	}

	.node-select,
	.dateSelect {
		.w(260) !important;
		// .h(40) !important;
	}

	.node-select {
		margin-right: 24rem;
	}
	
	.data-table {
		padding: 24rem;
		background-color: #fff;
		.w(1265);
		.h(908);

		.menu {
			// margin-top: 24rem;
			font-size: 18rem;
			.export {
				margin-left: 61rem;
			}

			.radio {
				margin-left: 24rem;

				.el-radio {
					margin-right: 20rem;
				}
			}
		}

		.title {
			font-size: 18rem;
			font-weight: bold;
			color: #333333;
		}
	}

	.diagram {
		.w(1265);
		.h(618);
		margin-top: 8rem;
		background-color: #fff;
		padding-left: 24rem;

		// display: flex;
		.exetext {
			.w(728);
			display: flex;
			align-items: center;
			justify-content: space-between;

			.exetext1 {
				display: flex;
				align-items: center;
			}
		}

		.left {
			width: 100%;
			.h(480);
		}

		.echarts {
			width: 100%;

			.left {
				width: 100%;
				.h(460);
			}

			.max-right {
				.w(272);
				// height: 380px;
				.h(460);
				margin-right: 24rem;

				.row-max {
					width: 100%;
					background-color: rgba(0, 43, 102, 0.02);
					// height: 88px;
					margin-bottom: 10px;

					.details {
						.w(176);
						height: 100%;
						padding: 12rem 0;

						span {
							margin-right: 8rem;
							color: rgba(13, 148, 255, 1);
							font-size: 16rem;

							&:first-child {
								color: #333333;
							}
						}
					}

					.max-name {
						height: 100%;
						.w(96);
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}
				}
			}
		}

		.showMax {
			div.left {
				.w(920) !important;
			}
		}

		.tab {
			width: 100%;
			.h(438);
			margin-top: 25rem;
		}

		.content {
			margin-top: 10rem;

			.dateSelect {
				font-size: 18rem;
				color: #000000 !important;
				margin-right: 8rem;
			}

			.max {
				.w(100);
				margin-left: 127rem;
			}

			.hose {
				display: flex;
				align-items: center;
			}
		}

		.select1 {
			margin-right: 27rem;
			font-size: 18rem;
			font-weight: 400;
			color: #333333;
			padding-top: 23rem;
			border-top: 2rem solid rgba(0, 0, 0, 0);
		}

		.select {
			> div {
				cursor: pointer;
				margin-right: 27rem;
				font-size: 18rem;
				font-weight: 400;
				color: #999999;
				padding-top: 21rem;
				border-top: 2rem solid rgba(0, 0, 0, 0);

				&.active {
					color: #0d94ff;
					font-weight: bold;
					border-top: 2rem solid #0d94ff;
				}
			}
		}
	}

	.real-data1 {
		.realLeft {
			padding: 24rem;
			.w(524);
			.h(342);
			background: #ffffff;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);

			.status {
				width: 100%;
				.h(220);
				margin-top: 57rem;
				background-color: #fff;
				display: flex;
				justify-content: space-between;
			}

			.operation {
				.w(232);
				height: 100%;
				background: rgba(0, 43, 102, 0.04);
				display: flex;
				justify-content: center;
				align-items: center;

				.ovall {
					.h(127);
					.w(71);
					display: grid;
					text-align: center;

					.totalStatus {
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}

					.boxStatus {
						font-size: 38rem;
						font-weight: bold;
						color: #68d86a;
					}

					.boxStatusOred {
						font-size: 38rem;
						font-weight: bold;
						color: #fd4238;
					}

					.boxStatusOBack {
						font-size: 38rem;
						font-weight: bold;
						color: #0d94ff;
					}
				}
			}

			.operation1 {
				.w(232);
				height: 100%;
				background: rgba(0, 43, 102, 0.04);
				display: flex;
				justify-content: center;
				align-items: center;

				.ovall {
					.h(127);
					.w(89);
					display: grid;
					text-align: center;

					.totalStatus {
						font-size: 18rem;
						font-weight: bold;
						color: #333333;
					}

					.boxStatus1 {
						// margin: auto;
						font-size: 18rem;

						.ax {
							width: 90%;
							margin: auto;
							display: flex;
							line-height: 28px;
							// justify-content: space-between;
							align-items: center;
							white-space: nowrap;
							font-size: 18rem;

							// p {
							//     font-size: 18rem;
							//     color: #333333;
							//     // white-space: nowrap
							// }

							.ax-2 {
								// display: flex;
								// justify-content: space-between;
								font-weight: 400;
								color: #0d94ff;
								font-size: 18rem;
								margin-right: 5rem
							}
						}
					}
				}
			}
		}

		.realRight {
			.w(724);
			.h(342);
			background: #ffffff;
			box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
			padding: 24rem;

			.foune-1 {
				display: flex;
				justify-content: space-between;

				// background-color: red;
				.tit-1 {
					display: flex;
					.w(170);
					justify-content: space-between;
					.h(69);
					font-size: 18rem;
					font-weight: 400;
					color: #333333;
				}
			}

			// .foune-2::-webkit-scrollbar {
			// width: 1px !important;
			// }
			.foune-2 {
				width: 100%;
				height: 80%;
				overflow-y: scroll;

				.oLi {
					width: 50%;
					height: 11%;
					background-color: #fff;
					// display: flex;
					border-top: rgba(0, 0, 0, 0.06) 1px solid;
					// align-items: center;
					float: left;

					.oli-Div {
						width: 100%;
						height: 100%;
						font-size: 18rem;
						display: flex;
						justify-content: space-between;
						padding-right: 35%;
					}
				}
			}
		}

		.tit {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			position: relative;
		}
	}

	.real-data {
		background-color: #ffffff;
		padding: 24rem;
		.h(342);

		.total-data {
			margin-top: 23rem;
			background: rgba(0, 43, 102, 0.04);
			border-radius: 4px;
			// padding-left: 8rem;
			line-height: 36rem;

			font-size: 18rem;
			font-weight: 400;
			color: #333333;

			.total-item {
				background-color: #fff;
				height: 100%;
			}

			.total-data-close {
				margin-left: 24rem;
				color: #fd4238;
				font-weight: bold;
			}

			.total-data-open {
				margin-left: 24rem;
				color: #68d86a;
				font-weight: bold;
			}
		}

		.PowerQuality-none {
			.w(280) !important;

			.val {
				.w(145) !important;
			}

			.key {
				width: auto !important;
				margin-left: 25rem;
				margin-right: 32rem;
			}
		}

		.data {
			.w(395);

			.details {
				.h(132);
				justify-content: space-between;
				margin-top: 23rem;

				.row {
					margin-bottom: 18rem;
				}

				.active {
					span {
						color: #fd4238;
					}
				}

				.key,
				.val {
					font-size: 14rem;
					color: #333333;
					font-weight: 400;
				}

				.key {
					.w(120);
					/*margin-right: 4rem;*/
				}

				.val {
					color: #0d94ff;
					.w(263);

					span {
						display: inline-block;
						width: 25%;
					}
				}
			}
		}

		.tit {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			position: relative;

			.location-right {
				.w(492);
				.h(236);
				position: absolute;
				right: 69rem;
				background-color: red;
				padding: 36rem 0 0 38rem;
				background: rgba(0, 43, 102, 0.04);

				.location-and {
					display: flex;
					align-items: center;
					height: 34rem;

					.location-img {
						width: 34rem;
						height: 34rem;
						margin-right: 5px;
					}

					img {
						width: 34rem;
						height: 34rem;
					}
				}

				.location-title {
					// font-size: 24px;

					font-size: 28rem;
					font-weight: bold;
					color: #68d86a;

					line-height: 30px;
				}

				.location-orag {
					font-size: 28rem;
					font-weight: bold;
					color: #f5aa00;

					line-height: 30px;
				}

				.location-item {
					margin-top: 35rem;
					.w(420);
					height: 63px;
					font-size: 16rem;
					font-weight: 400;
					color: #999999;
					word-wrap: break-word;
					word-break: break-all;
					overflow: hidden;
					/*这个参数根据需求来决定要不要*/
				}
			}
		}

		.name {
			font-size: 18rem;
			color: #333333;
			font-weight: bold;
			border-bottom: 1px solid rgba(0, 0, 0, 0.15);
			padding-bottom: 8rem;
			margin-top: 20rem;
			padding-left: 17rem;
		}
	}

	.Loopst {
		width: 475rem;
	}

	.breaker {
		display: flex;
		width: 100%;
		height: 100%;
		// background-color: rgba(0, 43, 102, 0.04);
		padding-left: 8rem;

		span {
			font-size: 18rem;
			font-weight: bold;
		}

		.k {
			color: #333333;
			margin-right: 24rem;
		}

		.v {
			color: red;
		}

		.Handcart {
			color: #0d94ff;
		}

		.sate {
			padding-left: 325rem;
		}
	}

	.ored {
		margin-left: 24rem;
		color: #fd4238;
		font-weight: bold;
	}

	.oglad {
		margin-left: 24rem;
		color: #68d86a;
		font-weight: bold;
	}

	.obalck {
		color: #0d94ff;
		font-weight: bold;
	}
</style>
